
import React from 'react';
import { Box, InputBase, IconButton, Avatar, Menu, MenuItem, Typography, Divider, ListItemIcon } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
// import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MenuIcon from '@mui/icons-material/Menu';
import { logout } from '../../utils/logout';
import { useNavigate } from 'react-router-dom';
import { Logout, Settings } from '@mui/icons-material';
import { usePermissions } from '../../utils/usePermissions';

interface TopbarProps {
  onMenuClick: () => void;
}

const Topbar: React.FC<TopbarProps> = ({ onMenuClick = () => { } }) => {
  const { canListControlPanel } = usePermissions();
  const navigate = useNavigate();

  const loginUser = JSON.parse(localStorage.getItem('loginUser') ?? 'null');

  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  function stringToColor(string: string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
  }

  function stringAvatar(name: string) {
    return {
      sx: {
        bgcolor: stringToColor(name),
      },
      // children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
      children: `${name.split(' ')[0][0]}`,
    };
  }

  const handleSettingsClick = () => {
    navigate('/controlPanel');
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: { xs: 1, sm: 2 },
        py: 1.5,
        bgcolor: 'white',
        minHeight: 64,
        borderRadius: 1.5,
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1200,
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      }}
    >
      {/* Left side - Search and Menu Button (mobile/tablet) */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        {/* Hamburger Menu Button for Mobile/Tablet */}
        <IconButton
          onClick={onMenuClick}
          sx={{
            display: { xs: 'flex', md: 'none' }, // Show only on mobile/tablet
            mr: 1
          }}
        >
          <MenuIcon />
        </IconButton>

        <Box
          sx={{
            bgcolor: 'secondary',
            border: '1px solid gray',
            borderRadius: 1,
            px: { xs: 1, sm: 2 },
            py: 0.5,
            display: 'flex',
            alignItems: 'center',
            flexGrow: 1,
          }}
        >
          <SearchIcon sx={{ color: '#8f5fe8', mr: 1 }} />
          <InputBase
            placeholder="Search"
            sx={{
              width: { xs: '100px', sm: 120, md: 150 },
              fontSize: { xs: '0.875rem', sm: '1rem' }
            }}
          />
        </Box>
      </Box>

      {/* Right side - Icons */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, sm: 2 } }}>
        {/* <IconButton size="small">
          <NotificationsNoneIcon fontSize="small" />
        </IconButton> */}
        {/* <Tooltip title="Control Panel">
          <IconButton onClick={handleSettingsClick} size="small">
            <SettingsOutlinedIcon fontSize="small" />
          </IconButton>
        </Tooltip> */}
        {/* {
          (!!isAuthenticated) ?
            <Tooltip title="Log Out">
              <IconButton onClick={logout} size="small">
                <LogoutIcon fontSize="small" />
              </IconButton>
            </Tooltip> : ""
        } */}
        <Box sx={{ flexGrow: 0 }}>
          <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
            <Avatar {...stringAvatar(loginUser.name)} />
          </IconButton>
          <Menu
            sx={{ mt: '45px' }}
            id="menu-appbar"
            anchorEl={anchorElUser}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={Boolean(anchorElUser)}
            onClose={handleCloseUserMenu}
          >
            <MenuItem onClick={() => navigate('/profile', {
              state: {
                userId: loginUser.userId,
              }
            })}>
              <ListItemIcon >
                <AccountCircleIcon fontSize="small" />
              </ListItemIcon>
              <Typography>{loginUser.userName}</Typography>
            </MenuItem>
            <Divider />
            {canListControlPanel() && (<MenuItem onClick={handleSettingsClick}>
              <ListItemIcon >
                <Settings fontSize="small" />
              </ListItemIcon>
              Control Panel
            </MenuItem>)}

            <MenuItem onClick={logout} sx={{ color: "red", fontSize: "14px", '&:hover': { backgroundColor: "error" } }}>
              <ListItemIcon >
                <Logout fontSize="small" color='error' />
              </ListItemIcon>
              Logout
            </MenuItem>
          </Menu>

        </Box>
      </Box>
    </Box>
  );
};

export default Topbar;